export default {
      id: "ic_green_arrow_up-usage",
      viewBox: "0 0 13 7",
      url: "/" + "images/icons.3.109.2.svg#ic_green_arrow_up-usage",
      toString: function () {
        return this.url;
      }
    }